<template>
  <div style="background-color: #f7f7f7; font-family: 'Arial';height: 100%;" >
    <div class="header__menu-admin" :class="bodyScroll">
      <div class="menu__admin-web" :class="{'menu__admin-web--hide':!menuMobile}">
          <div class="div-admin" :class="{'div-admin--hide':!menuMobile}">
                <mdb-card class="card-admin">
                  <button class="menu__mobile-button menu__mobile-button-closed" @click="menuMobile=false">
                    <mdb-icon  icon="times"  />
                  </button>
                  <mdb-card-avatar color="white" class="mx-auto rounded-circle card-admin-image">
                    <img
                      src="../../../public/img/Logo_blanco_Solicitudes.png"
                      class="rounded-circle"
                      
                    />
                  </mdb-card-avatar>
                  <mdb-card-body class="div-body card-menu">
                    <hr />
                    <p
                      v-if="loginUserType != 'SUPER_ADMIN'"
                      @mouseup="isOver = true"
                      @mousedown="isOver = false"
                      @mouseover="isOver = true"
                      @mouseleave="isOver = false"
                      @click="menuIndex = 1"
                      :class="colorOver"
                    >Dashboard</p>
                    <p
                    
                      @mouseup="isOver2 = true"
                      @mousedown="isOver2 = false"
                      @mouseover="isOver2 = true"
                      @mouseleave="isOver2 = false"
                      @click="menuIndex = 2"
                      :class="colorOver2"
                    >Solicitudes</p>
                    <p
                      v-if="loginUserType != 'PARTNER_SERVICE' && loginUserType != 'COMMITTEE' && loginUserType != 'SALES'"
                      @mouseup="isOver3 = true"
                      @mousedown="isOver3 = false"
                      @mouseover="isOver3 = true"
                      @mouseleave="isOver3 = false"
                      @click="menuIndex = 3"
                      :class="colorOver3"
                    >{{loginUserType == 'SUPER_ADMIN'?'Administradores':'Usuarios'}}</p>
                    <p
                      v-if="loginUserType != 'SUPER_ADMIN' && loginUserType != 'COMMITTEE' && loginUserType != 'SALES'"
                      @mouseup="isOver4 = true"
                      @mousedown="isOver4 = false"
                      @mouseover="isOver4 = true"
                      @mouseleave="isOver4 = false"
                      @click="menuIndex = 4"
                      :class="colorOver4"
                    >Pagos</p>

                    <p
                      v-if="loginUserType =='SUPER_ADMIN'"
                      @mouseup="isOver5 = true"
                      @mousedown="isOver5 = false"
                      @mouseover="isOver5 = true"
                      @mouseleave="isOver5 = false"
                      @click="menuIndex = 5"
                      :class="colorOver5"
                    >Clubs</p>

                    <mdb-dropdown  v-if="loginUserType === 'CLUB_ADMIN' || loginUserType == 'PARTNER_SERVICE'" class="my-5">
                      <mdb-dropdown-toggle :class="'z-depth-0 dropdown-trust1 text-capitalize '+colorOver6" slot="toggle">Configuración</mdb-dropdown-toggle>
                      <mdb-dropdown-menu class="dropdown-items-trust1">
                        <mdb-dropdown-item @click="menuIndex = 6" >Acciones</mdb-dropdown-item>
                        <div class="dropdown-divider"></div>
                        <mdb-dropdown-item  @click="menuIndex = 7" >Vendedores</mdb-dropdown-item>
                        <div class="dropdown-divider"></div>
                        <mdb-dropdown-item @click="menuIndex = 8" >Participantes de Comité y Recomendaciones de socios</mdb-dropdown-item>
                        <div class="dropdown-divider"></div>
                        <mdb-dropdown-item  @click="menuIndex = 9" >Trámites</mdb-dropdown-item>
                        <div class="dropdown-divider"></div>
                        <mdb-dropdown-item  @click="menuIndex = 10" >Tipos de usuarios</mdb-dropdown-item>
                      </mdb-dropdown-menu>
                    </mdb-dropdown>

                  </mdb-card-body>
                </mdb-card>

              </div>
      </div>
      <div class="header__admin">
        <HeaderAdmin :name="nameHeader" class="header-admin-custom" />
        <button class="menu__mobile-button menu__mobile-button-open" @click="menuMobile=true">
          <mdb-icon  icon="bars" />
        </button>
        <mdb-row class="mx-3 content__admin-dashboard">
          <mdb-col col="12" class="pb-4">
            <div v-if="menuIndex==1">
              <Dashboard />
            </div>
            <div v-else-if="menuIndex==2" class="space-mobile">
              <Solicitudes />
            </div>
            <div v-else-if="menuIndex==3" class="space-mobile">
              <!--USERS-->
              <Users />
            </div>
            <!---PAGOOS-->
            <div v-else-if="menuIndex==4" class="space-mobile">
              <Payments />
            </div>
            <div v-else-if="menuIndex === 6" class="space-mobile">
              <Membership />
            </div>
            <div v-else-if="menuIndex === 7" class="space-mobile">
              <Seller />
            </div>
            <div v-else-if="menuIndex === 8" class="space-mobile">
              <ParticipantsAndRecommendations />
            </div>
            <div v-else-if="menuIndex === 9" class="space-mobile">
              <Paperwork />
            </div>
            <div v-else-if="menuIndex === 10" class="space-mobile">
              <UserType />
            </div>
            <div v-else class="space-mobile">
              <Clubs />
            </div>
          </mdb-col>
        </mdb-row>
      </div>
    </div>
    <!-- <DropdownMenuAdmin /> -->
    
  </div>
</template>

<script>
//import t1btn from "../../components/core/Button";
import HeaderAdmin from "../../components/core/HeaderAdmin";
//import DropdownMenuAdmin from "../../components/core/DropdownMenuAdmin";
//import Popup from "../../components/core/Popup";
import Clubs from "../../components/content/AdminSections/Clubs";
import Users from "../../components/content/AdminSections/Users";
import UserType from "../../components/content/AdminSections/Configuration/UserType";
import ParticipantsAndRecommendations from "../../components/content/AdminSections/Configuration/ParticipantsAndRecommendations";
import Seller from "../../components/content/AdminSections/Configuration/Seller";
import Membership from "../../components/content/AdminSections/Configuration/Membership";
import Dashboard from "../../components/content/AdminSections/Dashboard";
import Paperwork from "../../components/content/AdminSections/Configuration/Paperwork";
import Solicitudes from "../../components/content/AdminSections/Applications";
import Payments from "../../components/content/AdminSections/Payments";
//import Acciones from "../../components/content/AdminSections/Acciones";
import { required, email } from "vuelidate/lib/validators";
/* import ValidationError from "./misc/ValidationError"; */
import { mapGetters, mapActions } from "vuex";
//import Swal from "sweetalert2";
import {
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  //mdbCardUp,
  mdbCardAvatar,
  mdbIcon,
  //mdbBtn,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle
} from "mdbvue";

export default {
  name: "Administrador",
  components: {
    Membership,
    HeaderAdmin,
    //DropdownMenuAdmin,
    ParticipantsAndRecommendations,
    mdbRow,
    UserType,
    Seller,
    mdbCol,
    mdbCard,
    mdbCardBody,
    //mdbCardUp,
    mdbCardAvatar,
    mdbIcon,
    //mdbBtn,
    //t1btn,
    //Popup,
   /*  ValidationError, */
    Clubs,
    Users,
    Dashboard,
    Solicitudes,
    Payments,
    Paperwork,
    //Acciones,
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle
  },
  data() {
    return {
      totalOfElements: 0,
      page: 1,
      perPage: 15,
      pages: [],
      numberOfPages: 0,
      search: "",
      dataList: [],
      showFilterUser: false,
      showFilterApp: false,
      menuIndex: 1,
      userPopTitle: "Agrega nuevos usuarios",
      userType: "",
      email: "",
      statusFilter: "revision",
      index: 1,
      indexPop: 1,
      isCorrect: false,
      isOver: false,
      isOver2: false,
      isOver3: false,
      isOver4: false,
      isOver5: false,
      isOver6: false,
      iconEdit: "editar-default.svg",
      iconDelete: "borrar-default.svg",
      checkedApp: [],
      menuMobile:false
    };
  },
  validations: {
    email: {
      required,
      email
    }
  },
  methods: {
    ...mapActions(["setDropdown"]),
    mouseOverIcon(module) {
      if (module == "edit") {
        let iconEdit = this.iconEdit.split("-");
        this.iconEdit = `${iconEdit[0]}-hover.svg`;
      } else if (module == "delete") {
        let iconDelete = this.iconDelete.split("-");
        this.iconDelete = `${iconDelete[0]}-hover.svg`;
      }
    },
    mouseLeaveIcon(module) {
      if (module == "edit") {
        let iconEdit = this.iconEdit.split("-");
        this.iconEdit = `${iconEdit[0]}-default.svg`;
      } else if (module == "delete") {
        let iconDelete = this.iconDelete.split("-");
        this.iconDelete = `${iconDelete[0]}-default.svg`;
      }
    },
    mouseDownIcon(module) {
      if (module == "edit") {
        let iconEdit = this.iconEdit.split("-");
        this.iconEdit = `${iconEdit[0]}-click.svg`;
      } else if (module == "delete") {
        let iconDelete = this.iconDelete.split("-");
        this.iconDelete = `${iconDelete[0]}-click.svg`;
      }
    },
    mouseUpIcon(module) {
      if (module == "edit") {
        let iconEdit = this.iconEdit.split("-");
        this.iconEdit = `${iconEdit[0]}-default.svg`;
      } else if (module == "delete") {
        let iconDelete = this.iconDelete.split("-");
        this.iconDelete = `${iconDelete[0]}-default.svg`;
      }
    },
    async setIndex(val){
      this.menuIndex = this.menu;

    }
  },
  async mounted() {
    await this.setIndex();
    if(this.loginUserType == 'SUPER_ADMIN'){
      this.menuIndex = 3;

    }
    
    if(jivo_api)
      jivo_api.close()
      
  },
  watch:{
    menuIndex(val){
      this.$store.commit("setMenuIndex", val)
    }
  },
  computed: {
    ...mapGetters({
      loginUserType: "getUserType",
      getDropdown: "getDropdown",
      menu: "getMenuIndex"
    }),
    checked: {
      get() {
        return this.getDropdown;
      },
      set(value) {
        this.setDropdown(value);
      }
    },
    openClass() {
      return this.open ? " t2-header__title--open" : "";
    },
    dropDownClasses() {
      return `t2-dropdown${this.visible}`;
    },
    visible() {
      return true ? ` t2-dropdown--open-admin` : ``;
    },
    nameHeader() {
      if (this.loginUserType == "SUPER_ADMIN") {
        return "Super administrador";
      }
      if (this.loginUserType == "CLUB_ADMIN") {
        return "Administrador de club";
      }
      if (this.loginUserType == "PARTNER_SERVICE") {
        return "Atención a socios";
      }
      if (this.loginUserType == "COMMITTEE") {
        return "Comité";
      }
      if (this.loginUserType == "SALES") {
        return "Ventas";
      }
    },
    colorOver() {
      return this.isOver ? "color-over" : "";
    },
    colorOver2() {
      return this.isOver2 ? "color-over" : "";
    },
    colorOver3() {
      return this.isOver3 ? "color-over" : "";
    },
    colorOver4() {
      return this.isOver4 ? "color-over" : "";
    },
    colorOver5() {
      return this.isOver5 ? "color-over" : "";
    },
    colorOver6() {
      return this.isOver6 ? "color-over" : "";
    },
    bodyScroll(){
       let bodyscroll = document.body
       let path = this.$route.path
       if(path==="/admin"){
         if(window.matchMedia("(min-width: 1025px)")){
           bodyscroll.style.overflowY="hidden"
         }else{
           bodyscroll.style.overflowY="scroll"
         }
         
       }
       return ''
     }
  },
};
</script>

<style >
/* fix styles */
html{
  height: 100%;
}
body{
  height: 100%;
}
#app{
  height: 100%;
}
/* end fix styles */
  .dropdown-trust1:hover{
    color:#dc7134;
  }
  .dropdown-trust1{
    font-size: 1.2rem;
    font-weight: bold;
    padding: 0!important;
  }
  .dropdown-items-trust1{
    background:#3a8a65;
    color:#fff;
    font-size: 1.5rem;
    border: 1px solid #fff
  }
  .dropdown-items-trust1 .dropdown-item{
    color:#fff;
    font-size: 1.1rem!important;
  }
  .dropdown-items-trust1 .dropdown-item:hover{
    background-color: #dc7134!important;
  }
  .dropdown-items-trust1 .dropdown-item:active{
    background-color: #dc7134!important;
  }
  .badge-trust1{
    background: #4cac81;
    color: white;
    border: 2px solid #285f46;
  }
.filterStyle {
  width: 40vw;
  padding: 0 2rem;
  position: absolute;
  z-index: 9;
}
.labelPop {
  font-size: 1.5rem;
  font-family: Open Sans;
  font-weight: 600;
  color: #285f46;
}

.navClass {
  position: absolute;
  margin: 0;
  right: 0;
  top: 2rem;
  left: 140%;
}
.searchBar {
  margin: auto;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 0;
  display: inline-block;
  padding: 4px;
}
.card-admin {
  background-color: #3a8a65;
  height: 100%;
  border-radius:0px;
  position: relative;
}

.div-body {
  text-align: left !important;
  font-size: 12px;
  color: white;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  padding-left: 25px;
  padding-right: 25px;
}
.div-body > p {
  padding-top: 30px;
  font-size: 18px;
}
.div-body button{
  font-size: 18px;
}

.color-over {
  color: #f78c4f !important;
  cursor: pointer;
}

.div-admin {
  height: 100%;
  /*padding-left: 20%;*/
  /* padding-top: 3rem; */
  /*padding-right: 20%;*/
}

.card-div {
  padding-top: 3rem;
  padding-bottom: 5rem;
}

/*.card-title {
  color: white;
  background: #3e8a66;
  border-radius: 2px 2px 0 0;
  height: 5rem;
  text-align: left;
  padding-left: 10px;
  padding-right: 40px;
  padding-top: 8px;
  font-size: 13px;
}*/
.card-body-c {
  margin-left: 25%;
  text-align: center;
}

/*.card-body-sn div {
  background: url("../../../public/img/InoNSolicitudes@3x.png") no-repeat scroll
    center;
  text-align: center;
  background-size: 60%;
  height: 100%;
  padding-top: 1.5rem;
  padding-right: 2rem;
  color: white;
  font-size: 18px;
  width: 85%;
  margin-left: 1.5rem;
}*/

/*.card-body-si div {
  background: url("../../../public/img/InoSInvestigación@3x.png") no-repeat
    scroll center;
  text-align: center;
  background-size: 40%;
  height: 110%;
  padding-top: 1.5rem;
  padding-right: 1rem;
  color: white;
  font-size: 18px;
  width: 85%;
  margin-left: 1.5rem;
}*/
/*.card-body-sc div {
  background: url("../../../public/img/InoSComité@3x.png") no-repeat scroll
    center;
  text-align: center;
  background-size: 60%;
  height: 100%;
  padding-top: 1.5rem;
  padding-right: 2rem;
  color: white;
  font-size: 18px;
  width: 80%;
  margin-left: 1.5rem;
}*/
/*.card-body-sa > div {
  background: url("../../../public/img/InoSAprobadas@3x.png") no-repeat scroll
    center;
  text-align: center;
  background-size: 47%;
  height: 130%;
  padding-top: 1.5rem;
  padding-right: 0rem;
  color: white;
  font-size: 18px;
  width: 85%;
  margin-left: 1.5rem;
}*/


.title-style {
  font-size: 25px;
  font-weight: 600;
  color: #3e8a66;
}

.input-style {
  height: 35px;
  width: 50vw;
  border: solid 0.5px #ffffff;
  font-size: 17px;
  font-weight: 100;
  padding-left: 10px;
  padding-right: 3vw;
  background: url("../../../public/img/InoBuscar@3x.png") no-repeat scroll 45vw
    7px #ffffff;
  background-size: 20px 20px;
  border-radius: 2.5px;
  box-shadow: 0 0.5px 2px 0 rgba(0, 0, 0, 0.25);
}

.circle-style {
 border-radius: 5px;
    border: 3px solid #285f46;
    height: 30px;
    width: 30px;
    background: #4cac81;
    color: white;
    font-size: 18px;
    padding-left: 5px;
    padding-top: 0px;
    font-weight: 500;

}

.circle-style2 {
  font-size: 25px;
  width: 6rem;
  height: 6rem;
  position: absolute;
  margin: auto;
  display: block;
  left: 31%;
  top: 33%;
  padding-left: 13px;
  padding-top: 9px;
  border-radius: 100%;
  border: 3px solid #285f46;
  background: #4cac81;
  color: white;
  font-weight: 500;
}

.t1-table td {
  color: #010101;
  font-weight: 400;
}

.t1-checkbox label {
  font-size: 1.4rem;
  cursor: pointer;
  color: black;
  font-family: Open Sans;
}

.dot_review_partner {
  width: 12px;
  height: 12px;
  background-color: #aa2ce2;
  border-radius: 100%;
  position: absolute;
  margin-top: 0.5rem;
  margin-left: -0.5rem;
}
.dot_accepted {
  width: 12px;
  height: 12px;
  background-color: #172de2;
  border-radius: 100%;
  position: absolute;
  margin-top: 0.5rem;
  margin-left: -0.5rem;
}

.dot_reserch_f {
  width: 12px;
  height: 12px;
  background-color:#ff6d01;
  border-radius: 100%;
  position: absolute;
  margin-top: 0.5rem;
  margin-left: -0.5rem;
}

.dot_declined {
  width: 12px;
  height: 12px;
  background-color:#666666;
  border-radius: 100%;
  position: absolute;
  margin-top: 0.5rem;
  margin-left: -0.5rem;
}
.dot_edit2 {
  width: 12px;
  height: 12px;
  background-color: #480400;
  border-radius: 100%;
  position: absolute;
  margin-top: 0.5rem;
  margin-left: -0.5rem;
}

.dot_documentation_finished {
  width: 12px;
  height: 12px;
  background-color: #006064;
  border-radius: 100%;
  position: absolute;
  margin-top: 0.5rem;
  margin-left: -0.5rem;
}

.dot_edit1 {
  width: 12px;
  height: 12px;
  background-color: #f1c232;
  border-radius: 100%;
  position: absolute;
  margin-top: 0.5rem;
  margin-left: -0.5rem;
}

.dot_finished {
  width: 12px;
  height: 12px;
  background-color: #317f43;
  border-radius: 100%;
  position: absolute;
  margin-top: 0.5rem;
  margin-left: -0.5rem;
}

.dot_created {
  width: 12px;
  height: 12px;
  background-color: #990000;
  border-radius: 100%;
  position: absolute;
  margin-top: 0.5rem;
  margin-left: -0.5rem;
}

.dot_review_committe {
  width: 12px;
  height: 12px;
  background-color: #d60992;
  border-radius: 100%;
  position: absolute;
  margin-top: 0.5rem;
  margin-left: -0.5rem;
}

.selectdiv {
  position: absolute;
  float: left;
  min-width: 120px;
  right: 0;
  top: 2rem;
}

/* IE11 hide native button (thanks Matt!) */
select::-ms-expand {
  display: none;
}

.selectdiv:after {
  content: ">";
  font: 17px "Consolas", monospace;
  color: #285f46;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: -4px;
  background-color: #47ad7e;
  /*Adjust for position however you want*/

  top: 5px;
  padding-left: 1rem;
  padding-top: 0rem;
  padding-bottom: 0rem;
  padding-right: 1rem;
  /*left line */

  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  width: 63%;
  /* max-width: 320px; */
  height: 30px;
  float: right;
  /* margin: 5px 0px; */
  padding: 0px 10px;
  font-size: 12px;
  /* line-height: 1.75; */
  color: #828282;
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #cccccc;
  -ms-word-break: normal;
  word-break: normal;
}

.buttonFilter {
  width: 50px;
  height: 40px;
  border-radius: 5px;
  background-color: #b5d1c4;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  padding: 4px;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  box-shadow: unset;
}

.btn-edit {
  padding: 6px;
  background-color: #c4c4c4 !important;
  border-radius: 3px;
  box-shadow: unset;
}
.btn-edit:hover {
  background-color: #f78c4f !important;
}
.btn-edit:active {
  background-color: #dc7134 !important;
}

.btn-add {
  position: absolute;
  float: right;
  min-width: 120px;
  top: 2rem;
}

.btn-accepted {
  padding: 6px;
  background-color: #c4c4c4 !important;
  border-radius: 3px;
  box-shadow: unset;
}

.btn-accepted:hover {
  background-color: #3a8a65 !important;
}

.btn-accepted:hover:active {
  background-color: #3a8a65 !important;
}

.btn-delete {
  padding: 6px;
  background-color: #c4c4c4 !important;
  border-radius: 3px;
  box-shadow: unset;
}

.btn-delete:hover {
  background-color: #eb5757 !important;
}

.btn-delete:active {
  background-color: #d65050 !important;
}

@media screen and (min-width: 1300px) {
  .circle-style2 {
    width: 8rem;
    height: 8rem;
    left: 30%;
    top: 30.5%;
    padding-left: 23px;
    padding-top: 19px;
  }
}
/* correction styles */
.header__menu-admin{
  display: flex;
  width: 100%;
  height: 100%;

}
.menu__admin-web{
  max-width: 320px;
  width: 25%;
  height: 100%;
}
.header__admin{
  width: inherit;
  height: 100%;
  position: relative;
}

.card-admin-image{
  margin-top: 50px;
}
.menu__mobile-button{
  /* 
  height: 25px; */
  width: 40px;
  font-size: 25px;
  position: absolute;
  top: 9px;
  left: 14px;
  color: #fff;
  background-color: transparent;
  border: none;
}
@media (min-width:1025px) {
  .menu__mobile-button-open{
    display: none;
  }
  .menu__mobile-button-closed{
    display: none;
  }
  .content__admin-dashboard{
    overflow-y: scroll;
    max-height: 100vh;
    padding-bottom: 7rem;
  }
  
}
@media (max-width:1024px) {
  /* .menu__admin-web{
    display: none;
  } */
  .content__admin-dashboard{
    overflow-y: scroll;
    max-height: 100vh;
    padding-bottom: 7rem;
  }
  .menu__mobile-button{
    display: inline-block;
  }
  .menu__admin-web{
    position:fixed;
    z-index: 9;
    width: 100%;
    width: 100%;
    max-width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    visibility: visible;
    opacity: 1;
    transition: 0.3s all;
  }
  .menu__admin-web.menu__admin-web--hide{
    visibility: hidden;
    opacity: 0;
    transition: 0.3s all;
  }
  .div-admin{
    max-width: 320px;
    width: 320px;
    overflow-y: scroll;
    transition: 0.2s;
  }
  .div-admin.div-admin--hide{
    width: 0px;
    transition: 0.2s all;
  }
  .space-mobile{
    margin-left: 15px;
    margin-right: 15px;
  }
}
@media (max-width:450px) {
  .div-admin{
    width: 260px;
  }
}
</style>